"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _useStylesUtils = require("../../hooks/useStylesUtils");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    fontFamily,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem,
    fontSizeProps,
    getMeasurement,
    getElementHeight
  } = (0, _useStylesUtils.useStylesUtils)();
  const {
    isDisabled = false,
    color = 'primary',
    shape = 'ellipse',
    size = 'medium',
    view = 'contained',
    pointerEvents = 'auto',
    customStyle = {}
  } = props;
  const ccButtonStyle = (0, _react.useMemo)(() => {
    const shapeProps = () => {
      let borderRadius;
      let aspectRatio;
      if (shape === 'rectangle' || view === 'link' || view === 'text') {
        borderRadius = 0;
      } else if (shape === 'round') {
        aspectRatio = '1';
        borderRadius = '50%';
      } else if (shape === 'roundedRectangle') {
        switch (size) {
          case 'x-small':
            borderRadius = pxToRem(3);
            break;
          case 'small':
            borderRadius = pxToRem(5);
            break;
          case 'medium':
          case 'large':
          case 'stretch':
            borderRadius = pxToRem(6);
            break;
          case 'x-large':
            borderRadius = pxToRem(8);
            break;
        }
      } else {
        borderRadius = pxToRem(25);
      }
      return {
        borderRadius,
        aspectRatio
      };
    };
    const viewShapeSizeProps = () => {
      let padding;
      switch (size) {
        case 'x-small':
          padding = `0 ${pxToRem(12)}`;
          break;
        case 'small':
          padding = `0 ${pxToRem(16)}`;
          break;
        case 'medium':
          padding = `0 ${pxToRem(24)}`;
          break;
        case 'large':
          padding = `0 ${pxToRem(24)}`;
          break;
        case 'x-large':
          padding = `0 ${pxToRem(28)}`;
          break;
        case 'stretch':
          padding = 0;
      }
      let height = getElementHeight(size);
      const btnWidth = shape === 'round' || size === 'stretch' ? height : 'auto';
      if (view === 'link' || view === 'text') {
        padding = pxToRem(0);
        height = 'auto';
      } else {
        if (shape === 'round') {
          padding = pxToRem(4);
        }
      }
      return {
        height,
        width: btnWidth,
        maxWidth: '100%',
        padding
      };
    };
    const colorViewProps = () => {
      let textColor;
      let background;
      let border;
      background = 'transparent';
      border = 'none';
      switch (color) {
        case 'primary':
          textColor = themeColors?.primary.main;
          switch (view) {
            case 'contained':
              background = `transparent linear-gradient(201.9deg, ${themeColors?.primary.start} 0%, ${themeColors?.primary.end} 100%) 0% 0% no-repeat padding-box`;
              textColor = themeColors?.general.light;
              break;
            case 'outlined':
              border = `1px solid ${themeColors?.primary.main}`;
              break;
            case 'alternate':
              background = themeColors?.primary.light;
              break;
            default:
              break;
          }
          break;
        case 'basic':
          textColor = themeColors?.general.text;
          switch (view) {
            case 'contained':
              background = themeColors?.basic.dark;
              textColor = themeColors?.general.light;
              break;
            case 'outlined':
              border = `1px solid ${themeColors?.general.border}`;
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
      return {
        background,
        color: textColor,
        border
      };
    };
    const hoverColorViewProps = () => {
      const backgroundColor = color === 'basic' && view === 'alternate' ? themeColors?.basic.main : color === 'primary' && view === 'alternate' ? themeColors?.primary.main : 'none';
      const textDecoration = view === 'link' ? 'underline' : 'none';
      if (view === 'alternate' && color === 'primary') {
        const color = themeColors?.general.light;
        return {
          backgroundColor,
          textDecoration,
          color
        };
      }
      return {
        backgroundColor,
        textDecoration
      };
    };
    const customStyleProps = () => {
      let customStyleObj = {}; //todo: fix type
      if (customStyle) {
        for (const [key, value] of Object.entries(customStyle)) {
          if (key === 'paddingInline') {
            customStyleObj[key] = getMeasurement(value);
          } else {
            customStyleObj[key] = value;
          }
        }
        return customStyleObj;
      }
      return {};
    };
    const disabledProps = () => {
      if (isDisabled) {
        return {
          opacity: '.5',
          cursor: 'default'
        };
      }
      return {};
    };
    const ccButton = (0, _css.css)({
      position: 'relative',
      fontFamily: fontFamily,
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      textDecoration: 'none',
      cursor: 'pointer',
      backgroundColor: 'transparent',
      pointerEvents: pointerEvents,
      ...fontSizeProps(size),
      ...shapeProps(),
      ...viewShapeSizeProps(),
      ...colorViewProps(),
      ...customStyleProps(),
      ...disabledProps(),
      '&:focus': {
        ...hoverColorViewProps()
      },
      '&:hover': {
        ...hoverColorViewProps()
      }
    });
    return ccButton;
  }, [fontFamily, pointerEvents, fontSizeProps, size, shape, view, pxToRem, getElementHeight, color, themeColors?.primary.main, themeColors?.primary.start, themeColors?.primary.end, themeColors?.primary.light, themeColors?.general.text, themeColors?.general.light, themeColors?.general.border, themeColors?.basic.dark, themeColors?.basic.main, customStyle, getMeasurement, isDisabled]);
  return {
    'cc-Button': ccButtonStyle
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;